import type { ICartItem } from '$lib/components/cart/store.svelte';

export class KwankoProvider {
	protected mcclic: string;
	protected currency: string;

	constructor(mcclic: string, currency: string) {
		this.mcclic = mcclic;
		this.currency = currency;
	}

	#trackEvent(zone: string, params?: Record<string, unknown>) {
		if (typeof KWKUniJS !== 'undefined') {
			KWKUniJS.ptag({
				zone,
				gdpr_kwk,
				gdpr_consent,
				...params,
			});
		}
	}

	trackConversion(order: SalesOrder) {
		if (typeof KWKUniJS !== 'undefined') {
			KWKUniJS.conversion({
				mclic: this.mcclic,
				argmon: (
					order.grand_total -
					order.shipping_amount -
					order.tax_amount +
					order.shipping_tax_amount
				).toFixed(2),
				argann: order.ref,
				argmodp: '',
				nacur: order.currency,
				argbr: order.coupon_code ?? '',
				gdpr_kwk: gdpr_kwk,
				gdpr_consent: gdpr_consent,
			});
		}
	}

	trackHomePage() {
		this.#trackEvent('homepage');
	}

	trackTransaction(order: SalesOrder) {
		const listItems = order.items.map((item) => ({
			id: item.sku,
			quantity: item.quantity,
			price: (
				item.unit_price * item.quantity -
				item.discount_amount +
				item.discount_tax_amount
			).toFixed(2),
		}));

		this.#trackEvent('transaction', {
			products: JSON.stringify(listItems),
			transactionId: order.ref,
			currency: order.currency,
		});
	}

	trackProduct(product: Product) {
		this.#trackEvent('product', {
			productId: product.data.sku,
			categoryId: '',
		});
	}

	trackBasket(cartItems: ICartItem[]) {
		if (
			cartItems[0].unit_price_excl_tax === undefined ||
			cartItems[0].discount_amount === undefined ||
			cartItems[0].discount_tax_amount === undefined
		) {
			return;
		}

		const listItems = cartItems.map((item) => ({
			id: item.sku,
			quantity: item.quantity,
			price: (
				item.unit_price_excl_tax * item.quantity -
				item.discount_amount +
				item.discount_tax_amount
			).toFixed(2),
		}));

		this.#trackEvent('basket', {
			products: JSON.stringify(listItems),
			currency: this.currency,
		});
	}
}

export default KwankoProvider;
